import React, { useState, useEffect } from "react";
import Faq from "../components/FAQ";
import Navbar from "../components/Navbar";
import Footer from "../components/navigation/Footer";
import Loader from "../components/Loader";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import LeaderboardTable from "../components/LeaderBoard";
import { Link } from "react-router-dom";
import Tiers from "./tiers";
import CallToAction from "../components/CTA";
import Livechat from "../components/LiveChat";
import Maintenance from "../components/Maintenance";
import UpgradeBanner from "../components/lib/Banner";
import CookieAlert from "../components/lib/UpgradeBanner";

const Home = () => {
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    // Set a timeout of 4 seconds (4000 milliseconds) to show the component
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, 4000);

    // Cleanup the timeout when the component unmounts
    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="bg-[#0a0c0f]">
      {/* <Maintenance /> */}
      <div className="">
        <div>
          <Livechat />
        </div>
        <div>
          <Loader />
        </div>
        {/* <UpgradeBanner /> */}
        {showComponent ? (
          <CookieAlert
            showComponent={showComponent}
            setShowComponent={setShowComponent}
          />
        ) : null}
        <Navbar />
        <div className="px-5 sm:px-10 md:px-20 lg:px-32 mb-32 group/wrap relative">
          <div className="text-center mb-20 pt-10 md:my-32">
            <div className="text-gray-300 pt-10">
              <div class="relative snap-y snap-mandatory overflow-y-auto scroll-smooth">
                <div class="group w-full snap-start">
                  <div>
                    <div class="overflow-hidden">
                      <div class="group-hover/wrap:translate-y-full group-only:animate-reveal group-only:animation-delay-[4000ms]">
                        <h1 className="font-semibold text-[45px] leading-[54px] md:text-[65px] md:leading-[78px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200">
                          Best algorithmic strategies for
                        </h1>
                      </div>
                    </div>
                    <div class="overflow-hidden">
                      <div class="group-hover/wrap:translate-y-full group-only:animate-reveal group-only:animation-delay-[4300ms]">
                        <h1 className="font-semibold text-[45px] leading-[54px] md:text-[65px] mb-4 md:leading-[78px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200">
                          digital asset management
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="font-medium text-gray-400 max-w-[500px] text-center mx-auto">
                Algoo Strategies offers this algorithmic trading strategy and
                other asset management tools through a decentralized
                organization, as all their projects run on the ERC-20
                block-chain.
              </p>
              <div className="sm:space-x-5 mt-8 sm:mt-5 block sm:flex max-[640px]:space-y-3 items-center justify-center">
                <button className="bg-[#b2ffce] w-full sm:w-auto rounded-lg px-10 py-2 font-semibold text-black">
                  <Link to="/strategies">View Strategies</Link>
                </button>
                <button className="bg-[#b2ffce] w-full sm:w-auto rounded-lg px-10 py-2 font-semibold text-black">
                  <Link to="/signup">Get Started</Link>
                </button>
              </div>
            </div>
          </div>
          <div>
            <AnimationOnScroll animateIn="animate__fadeIn">
              <h1 className="font-medium animated mx-auto max-w-[1000px] text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 text-center mb-20">
                Core investments offered by Algoo Strategies
              </h1>
            </AnimationOnScroll>

            <AnimationOnScroll
              animateIn="animate__fadeIn"
              className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-5 mb-48"
            >
              <a
                href="https://wiki.algoostrategies.org/algoo-strategies-wiki/investment-products/fixed-yield-strategies"
                target="_blank"
                rel="noreferrer"
              >
                <div className="p-5 rounded-xl md:rounded-md bg-[#181b20] hover:animate-pulse">
                  <div className="mb-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <script xmlns="" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3 4C3 3.44772 3.44772 3 4 3H44C44.5523 3 45 3.44772 45 4C45 4.55228 44.5523 5 44 5H42V19.2C42 23.6804 42 25.9206 41.1281 27.6319C40.3611 29.1372 39.1372 30.3611 37.6319 31.1281C35.9206 32 33.6804 32 29.2 32H25V37.4338L34.5145 43.1425C34.9881 43.4267 35.1416 44.0409 34.8575 44.5145C34.5733 44.9881 33.9591 45.1416 33.4855 44.8575L25 39.7662V44C25 44.5523 24.5523 45 24 45C23.4477 45 23 44.5523 23 44V39.7662L14.5145 44.8575C14.0409 45.1416 13.4267 44.9881 13.1425 44.5145C12.8584 44.0409 13.0119 43.4267 13.4855 43.1425L23 37.4338V32H18.8C14.3196 32 12.0794 32 10.3681 31.1281C8.86278 30.3611 7.63894 29.1372 6.87195 27.6319C6 25.9206 6 23.6804 6 19.2V5H4C3.44772 5 3 4.55228 3 4ZM32.5549 16.8321C33.0144 16.5257 33.1386 15.9049 32.8323 15.4453C32.5259 14.9858 31.9051 14.8616 31.4455 15.168L26.1275 18.7132L22.7072 15.2929C22.3701 14.9558 21.842 14.9035 21.4454 15.1679L15.4453 19.1679C14.9858 19.4743 14.8616 20.0951 15.1679 20.5547C15.4743 21.0142 16.0952 21.1384 16.5547 20.832L21.8727 17.2868L25.2929 20.7071C25.63 21.0441 26.1581 21.0964 26.5547 20.832L32.5549 16.8321Z"
                        fill="#9D70FF"
                      />
                    </svg>
                  </div>
                  <div>
                    <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                      Fixed Yields
                      <br />
                      <span className="text-gray-400">Strategies</span>
                    </h2>
                    <p className="text-gray-400 text-sm font-medium">
                      The fundamental strategy of Algoo's platform allows for
                      investors to earn a fixed yield on core crypto assets
                    </p>
                  </div>
                </div>
              </a>
              <div className="p-5 rounded-xl md:rounded-md bg-[#181b20] relative">
                <div className="mb-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <script xmlns="" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23.1539 3L23.2 3L24.8 3L24.8461 3C28.1674 3 30.7213 3 32.763 3.16682C34.8259 3.33536 36.4539 3.67916 37.9019 4.41692C40.348 5.66327 42.3367 7.65202 43.5831 10.0981C44.3208 11.5461 44.6646 13.1741 44.8332 15.237C45 17.2787 45 19.8325 45 23.1537L45 23.1538L45 23.1539L45 23.2L45 24.8L45 24.8462L45 24.8462L45 24.8463C45 28.1675 45 30.7213 44.8332 32.763C44.6646 34.8259 44.3208 36.4539 43.5831 37.9019C42.3367 40.348 40.348 42.3367 37.9019 43.5831C36.4539 44.3208 34.8259 44.6647 32.763 44.8332C30.7213 45 28.1675 45 24.8463 45L24.8462 45L24.8461 45L24.8 45L23.2 45L23.1538 45L23.1538 45L23.1537 45C19.8325 45 17.2787 45 15.237 44.8332C13.1741 44.6647 11.5461 44.3209 10.0981 43.5831C7.65201 42.3367 5.66327 40.348 4.41691 37.9019C3.67915 36.4539 3.33535 34.8259 3.16681 32.763C2.99999 30.7213 2.99999 28.1674 3 24.8461L3 24.8L3 23.2L3 23.1539C2.99999 19.8326 2.99999 17.2787 3.16681 15.237C3.33535 13.1741 3.67915 11.5461 4.41691 10.0981C5.66327 7.65202 7.65201 5.66327 10.0981 4.41692C11.5461 3.67916 13.1741 3.33536 15.237 3.16682C17.2787 3 19.8326 3 23.1539 3ZM28.832 17.4453C28.6466 17.1671 28.3343 17 28 17C27.6656 17 27.3534 17.1671 27.1679 17.4453L20 28.1972L16.832 23.4453C16.6466 23.1671 16.3343 23 16 23L12 23C11.4477 23 11 23.4477 11 24C11 24.5523 11.4477 25 12 25L15.4648 25L19.1679 30.5547C19.3534 30.8329 19.6656 31 20 31C20.3343 31 20.6466 30.8329 20.832 30.5547L28 19.8028L31.1679 24.5547C31.3534 24.8329 31.6656 25 32 25L36 25C36.5523 25 37 24.5523 37 24C37 23.4477 36.5523 23 36 23L32.5352 23L28.832 17.4453Z"
                      fill="#FF8058"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                    Dynamic Yields
                    <br />
                    <span className="text-gray-400">Strategies</span>
                  </h2>
                  <p className="text-gray-400 text-sm font-medium">
                    A newly-implemented strategy offering dynamic yields subject
                    to market conditions
                  </p>
                </div>
                <div className="bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 py-1 px-1 max-[768px]:w-[70px] md:px-3 rounded-full absolute top-5 right-5">
                  <p className="text-[10px] font-medium">Coming soon</p>
                </div>
              </div>
              <div className="p-5 rounded-xl md:rounded-md bg-[#181b20] relative">
                <div className="mb-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <script xmlns="" />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M31.0709 11L22 11C20.1225 11 18.7645 11.0005 17.6908 11.0738C16.6261 11.1465 15.9141 11.2873 15.3212 11.5328C13.606 12.2433 12.2433 13.606 11.5328 15.3212C11.3366 15.7951 11.2072 16.3449 11.1261 17.0901C14.4567 17.6287 17 20.5174 17 24C17 27.4826 14.4567 30.3713 11.1261 30.9099C11.2072 31.6551 11.3366 32.2049 11.5328 32.6788C12.2433 34.394 13.606 35.7567 15.3212 36.4672C15.9141 36.7128 16.6261 36.8536 17.6908 36.9262C18.7645 36.9995 20.1225 37 22 37L31.0709 37C31.5561 33.6077 34.4735 31 38 31C41.866 31 45 34.134 45 38C45 41.866 41.866 45 38 45C34.4735 45 31.5561 42.3923 31.0709 39L22 39L21.9624 39L21.9624 39L21.9623 39L21.9623 39L21.9622 39L21.9622 39C20.1303 39 18.7044 39 17.5547 38.9216C16.3881 38.842 15.4331 38.6783 14.5558 38.3149C12.3506 37.4015 10.5985 35.6494 9.68508 33.4442C9.37498 32.6955 9.21031 31.8902 9.11922 30.9451C5.669 30.512 3 27.5677 3 24C3 20.4323 5.669 17.488 9.11922 17.0549C9.21031 16.1098 9.37498 15.3045 9.68508 14.5559C10.5985 12.3506 12.3506 10.5985 14.5558 9.68509C15.4331 9.32172 16.3881 9.15804 17.5547 9.07845C18.7044 9 20.1304 9 21.9624 9.00001L21.9625 9.00001L22 9.00001L31.0709 9.00001C31.5561 5.60771 34.4735 3.00001 38 3.00001C41.866 3.00001 45 6.13401 45 10C45 13.866 41.866 17 38 17C34.4735 17 31.5561 14.3923 31.0709 11Z"
                      fill="#56FFAE"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                    Yield Automated
                    <br />
                    <span className="text-gray-400">Portfolio</span>
                  </h2>
                  <p className="text-gray-400 text-sm font-medium">
                    A strategy which allows clients to hold a basket of crypto
                    assets within a single share while generating yield on top
                    of that share.
                  </p>
                </div>
                <div className="bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 py-1 px-1 max-[768px]:w-[70px] md:px-3 rounded-full absolute top-5 right-5">
                  <p className="text-[10px] font-medium">Coming soon</p>
                </div>
              </div>
              <a
                href="https://wiki.algoostrategies.org/algoo-strategies-wiki/investment-products/cedefi-strategies"
                target="_blank"
                rel="noreferrer"
              >
                <div className="p-5 rounded-xl md:rounded-md bg-[#181b20] hover:animate-pulse">
                  <div className="mb-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <script xmlns="" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.0549 11H10H9.96449C9.06273 11 8.33531 11 7.74331 11.0404C7.13456 11.0819 6.59628 11.1695 6.08658 11.3806C4.86144 11.8881 3.88807 12.8614 3.3806 14.0866C3.16948 14.5963 3.08191 15.1346 3.04038 15.7433C2.99999 16.3353 2.99999 17.0627 3 17.9645L3 18L3 18.0355C2.99999 18.9373 2.99999 19.6647 3.04038 20.2567C3.08191 20.8654 3.16948 21.4037 3.3806 21.9134C3.88807 23.1386 4.86144 24.1119 6.08658 24.6194C6.59628 24.8305 7.13456 24.9181 7.74331 24.9596C8.33531 25 9.06272 25 9.96448 25H10H15V24C15 23.4477 15.4477 23 16 23C16.5523 23 17 23.4477 17 24V25H31V24C31 23.4477 31.4477 23 32 23C32.5523 23 33 23.4477 33 24V25H38H38.0355C38.9373 25 39.6647 25 40.2567 24.9596C40.8654 24.9181 41.4037 24.8305 41.9134 24.6194C43.1386 24.1119 44.1119 23.1386 44.6194 21.9134C44.8305 21.4037 44.9181 20.8654 44.9596 20.2567C45 19.6647 45 18.9373 45 18.0355V18V17.9645C45 17.0627 45 16.3353 44.9596 15.7433C44.9181 15.1346 44.8305 14.5963 44.6194 14.0866C44.1119 12.8614 43.1386 11.8881 41.9134 11.3806C41.4037 11.1695 40.8654 11.0819 40.2567 11.0404C39.6647 11 38.9373 11 38.0355 11H38H32.9451C32.4476 6.50005 28.6326 3 24 3C19.3674 3 15.5524 6.50005 15.0549 11ZM15 29V30.0001C15 30.5524 15.4477 31.0001 16 31.0001C16.5523 31.0001 17 30.5524 17 30.0001V29H31V30.0001C31 30.5524 31.4477 31.0001 32 31.0001C32.5523 31.0001 33 30.5524 33 30.0001V29H42C42.5523 29 43 29.4477 43 30V31.2V31.2453V31.2453V31.2454V31.2454V31.2455C43 33.4473 43 35.1611 42.8877 36.5358C42.7736 37.9317 42.5388 39.0658 42.0191 40.0859C41.1562 41.7794 39.7794 43.1562 38.0859 44.0191C37.0658 44.5388 35.9317 44.7736 34.5358 44.8877C33.161 45 31.4472 45 29.2452 45H29.2H18.8H18.7548C16.5528 45 14.839 45 13.4642 44.8877C12.0683 44.7736 10.9342 44.5388 9.91409 44.0191C8.22063 43.1562 6.8438 41.7794 5.98094 40.0859C5.46117 39.0658 5.22636 37.9317 5.11232 36.5358C4.99999 35.161 5 33.4472 5 31.2453V31.2V30C5 29.4477 5.44772 29 6 29H15ZM17.0709 11C17.5561 7.60771 20.4735 5 24 5C27.5265 5 30.4439 7.60771 30.9291 11H17.0709Z"
                        fill="#52B6FF"
                      />
                    </svg>
                  </div>
                  <div>
                    <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                      CeDeFi
                      <br />
                      <span className="text-gray-400">Strategies</span>
                    </h2>
                    <p className="text-gray-400 text-sm font-medium">
                      Strategies with variable risk-reward levels built from
                      algorithmic tools utilizing the infrastructures of both
                      DeFi and CeFi
                    </p>
                  </div>
                </div>
              </a>
            </AnimationOnScroll>
          </div>
          <div className="mb-48">
            <AnimationOnScroll
              animateIn="animate__fadeIn"
              // className="md:grid space-y-10 md:space-y-0 grid-cols-4 gap-8 bg-[#181b20] rounded-md mx-3 md:mx-10 py-8 md:py-16 px-5 md:px-10"
            >
              <div>
                <h1 className="font-medium max-w-[1000px] text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 text-center mx-auto mb-20">
                  A crypto community focused on building wealth through passive
                  income
                </h1>
              </div>
              <div className="text-center max-sm:space-y-10 max-md:gap-12 sm:grid grid-cols-2 md:grid-cols-4 my-14 md:my-20">
                <div>
                  <h1 className="text-gray-300 justify-center font-medium text-3xl md:text-4xl mb-2">
                    $160M+
                  </h1>
                  <p className="text-gray-400">Assets under management</p>
                </div>
                <div>
                  <h1 className="text-gray-300 justify-center font-medium text-3xl md:text-4xl mb-2">
                    8000+
                  </h1>
                  <p className="text-gray-400">
                    Active investors earning daily yield
                  </p>
                </div>
                <div>
                  <h1 className="text-gray-300 justify-center font-medium text-3xl md:text-4xl mb-2">
                    $12M+
                  </h1>
                  <p className="text-gray-400">Paid out to customers</p>
                </div>
                <div>
                  <h1 className="text-gray-300 justify-center font-medium text-3xl md:text-4xl mb-2">
                    Over 20
                  </h1>

                  <p className="text-gray-400">Pools available to invest.</p>
                </div>
              </div>
              <div className="max-sm:flex-col flex items-center bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 rounded-lg p-10 mx-auto w-fit justify-center space-x-4 my-4 md:mt-10">
                <div className="w-[50%]">
                  <div>
                    <svg
                      viewBox="0 0 127 22"
                      className="max-[768px]:mx-auto w-[50%]"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 8.1142H9.88727L8.00557 2L6.11274 8.1142L0 8.10249L4.94363 11.8858L3.0508 18L7.99443 14.2167L12.9381 18L11.0564 11.8858L16 8.1142Z"
                        fill="#00AD74"
                      ></path>
                      <path
                        d="M11.4795 13.2679L11.0564 11.8858L8.00557 14.2167L11.4795 13.2679Z"
                        fill="#004D26"
                      ></path>
                      <path
                        d="M24.7102 4.99006V2.45455H36.6562V4.99006H32.2031V17H29.1634V4.99006H24.7102ZM38.2339 17V6.09091H41.1672V7.99432H41.2808C41.4797 7.31723 41.8135 6.80587 42.2822 6.46023C42.751 6.10985 43.2908 5.93466 43.9016 5.93466C44.0531 5.93466 44.2164 5.94413 44.3916 5.96307C44.5668 5.98201 44.7207 6.00805 44.8533 6.04119V8.72585C44.7112 8.68324 44.5147 8.64536 44.2638 8.61222C44.0128 8.57907 43.7832 8.5625 43.5749 8.5625C43.1298 8.5625 42.7321 8.65956 42.3817 8.85369C42.036 9.04309 41.7614 9.30824 41.5578 9.64915C41.3589 9.99006 41.2595 10.383 41.2595 10.8281V17H38.2339ZM54.2133 12.3551V6.09091H57.2389V17H54.334V15.0185H54.2204C53.9742 15.6577 53.5646 16.1714 52.9917 16.5597C52.4235 16.9479 51.7299 17.142 50.9107 17.142C50.1816 17.142 49.54 16.9763 48.986 16.6449C48.432 16.3134 47.9988 15.8423 47.6863 15.2315C47.3785 14.6207 47.2223 13.8892 47.2175 13.0369V6.09091H50.2431V12.4972C50.2478 13.1411 50.4207 13.6501 50.7616 14.0241C51.1025 14.3982 51.5594 14.5852 52.1323 14.5852C52.4969 14.5852 52.8378 14.5024 53.155 14.3366C53.4723 14.1662 53.728 13.9152 53.9221 13.5838C54.121 13.2524 54.218 12.8428 54.2133 12.3551ZM69.5357 9.2017L66.7658 9.37216C66.7184 9.13542 66.6166 8.92235 66.4604 8.73295C66.3041 8.53883 66.0982 8.38494 65.8425 8.27131C65.5915 8.15294 65.2909 8.09375 64.9405 8.09375C64.4717 8.09375 64.0764 8.19318 63.7544 8.39205C63.4324 8.58617 63.2715 8.84659 63.2715 9.1733C63.2715 9.43371 63.3756 9.65388 63.584 9.83381C63.7923 10.0137 64.1498 10.1581 64.6564 10.267L66.6308 10.6648C67.6914 10.8826 68.4822 11.233 69.003 11.7159C69.5238 12.1989 69.7842 12.8333 69.7842 13.6193C69.7842 14.3343 69.5735 14.9616 69.1521 15.5014C68.7355 16.0412 68.1625 16.4626 67.4334 16.7656C66.709 17.0639 65.8732 17.2131 64.9263 17.2131C63.4822 17.2131 62.3316 16.9124 61.4746 16.3111C60.6223 15.705 60.1228 14.8812 59.976 13.8395L62.9518 13.6832C63.0418 14.1236 63.2596 14.4598 63.6053 14.6918C63.9509 14.919 64.3936 15.0327 64.9334 15.0327C65.4637 15.0327 65.8898 14.9309 66.2118 14.7273C66.5385 14.5189 66.7042 14.2514 66.709 13.9247C66.7042 13.6501 66.5882 13.4252 66.3609 13.25C66.1337 13.0701 65.7833 12.9328 65.3098 12.8381L63.4206 12.4616C62.3553 12.2486 61.5622 11.8793 61.0413 11.3537C60.5252 10.8281 60.2672 10.1581 60.2672 9.34375C60.2672 8.64299 60.4566 8.0393 60.8354 7.53267C61.2189 7.02604 61.7563 6.63542 62.4476 6.3608C63.1436 6.08617 63.958 5.94886 64.8908 5.94886C66.2686 5.94886 67.3529 6.24006 68.1436 6.82244C68.9391 7.40483 69.4031 8.19792 69.5357 9.2017ZM78.292 6.09091V8.36364H71.7224V6.09091H78.292ZM73.2139 3.47727H76.2394V13.6477C76.2394 13.9271 76.282 14.1449 76.3673 14.3011C76.4525 14.4527 76.5709 14.5592 76.7224 14.6207C76.8786 14.6823 77.0585 14.7131 77.2621 14.7131C77.4042 14.7131 77.5462 14.7012 77.6883 14.6776C77.8303 14.6491 77.9392 14.6278 78.015 14.6136L78.4908 16.8651C78.3393 16.9124 78.1263 16.9669 77.8516 17.0284C77.577 17.0947 77.2432 17.1349 76.8502 17.1491C76.121 17.1776 75.4818 17.0805 74.9326 16.858C74.3881 16.6354 73.9643 16.2898 73.6613 15.821C73.3583 15.3523 73.2091 14.7604 73.2139 14.0455V3.47727ZM81.0629 21.0909V6.09091H84.0458V7.9233H84.1808C84.3133 7.62973 84.5051 7.33144 84.756 7.02841C85.0117 6.72064 85.3432 6.46496 85.7504 6.26136C86.1623 6.05303 86.6737 5.94886 87.2844 5.94886C88.0799 5.94886 88.8138 6.1572 89.4862 6.57386C90.1585 6.9858 90.6959 7.60843 91.0984 8.44176C91.5008 9.27036 91.7021 10.3097 91.7021 11.5597C91.7021 12.7765 91.5056 13.804 91.1126 14.642C90.7243 15.4754 90.194 16.1075 89.5217 16.5384C88.854 16.9645 88.1059 17.1776 87.2773 17.1776C86.6902 17.1776 86.1907 17.0805 85.7788 16.8864C85.3716 16.6922 85.0378 16.4484 84.7773 16.1548C84.5169 15.8565 84.3181 15.5559 84.1808 15.2528H84.0884V21.0909H81.0629ZM84.0245 11.5455C84.0245 12.1941 84.1145 12.7599 84.2944 13.2429C84.4743 13.7259 84.7347 14.1023 85.0756 14.3722C85.4165 14.6373 85.8308 14.7699 86.3185 14.7699C86.811 14.7699 87.2276 14.6349 87.5685 14.3651C87.9094 14.0904 88.1675 13.7116 88.3427 13.2287C88.5226 12.741 88.6126 12.1799 88.6126 11.5455C88.6126 10.9157 88.525 10.3617 88.3498 9.88352C88.1746 9.4053 87.9165 9.03125 87.5756 8.76136C87.2347 8.49148 86.8157 8.35653 86.3185 8.35653C85.8261 8.35653 85.4094 8.48674 85.0685 8.74716C84.7324 9.00758 84.4743 9.37689 84.2944 9.85511C84.1145 10.3333 84.0245 10.8968 84.0245 11.5455ZM94.5191 17V6.09091H97.5447V17H94.5191ZM96.039 4.68466C95.5892 4.68466 95.2033 4.53551 94.8813 4.23722C94.5641 3.93419 94.4055 3.57197 94.4055 3.15057C94.4055 2.7339 94.5641 2.37642 94.8813 2.07812C95.2033 1.77509 95.5892 1.62358 96.039 1.62358C96.4888 1.62358 96.8723 1.77509 97.1896 2.07812C97.5115 2.37642 97.6725 2.7339 97.6725 3.15057C97.6725 3.57197 97.5115 3.93419 97.1896 4.23722C96.8723 4.53551 96.4888 4.68466 96.039 4.68466ZM103.794 2.45455V17H100.768V2.45455H103.794ZM111.947 17.2131C110.843 17.2131 109.889 16.9787 109.084 16.5099C108.284 16.0365 107.666 15.3783 107.231 14.5355C106.795 13.688 106.577 12.7055 106.577 11.5881C106.577 10.4612 106.795 9.47633 107.231 8.63352C107.666 7.78598 108.284 7.12784 109.084 6.65909C109.889 6.18561 110.843 5.94886 111.947 5.94886C113.05 5.94886 114.001 6.18561 114.802 6.65909C115.607 7.12784 116.227 7.78598 116.662 8.63352C117.098 9.47633 117.316 10.4612 117.316 11.5881C117.316 12.7055 117.098 13.688 116.662 14.5355C116.227 15.3783 115.607 16.0365 114.802 16.5099C114.001 16.9787 113.05 17.2131 111.947 17.2131ZM111.961 14.8693C112.463 14.8693 112.882 14.7273 113.218 14.4432C113.554 14.1544 113.807 13.7614 113.978 13.2642C114.153 12.767 114.241 12.2012 114.241 11.5668C114.241 10.9323 114.153 10.3665 113.978 9.86932C113.807 9.37216 113.554 8.97917 113.218 8.69034C112.882 8.40151 112.463 8.2571 111.961 8.2571C111.454 8.2571 111.028 8.40151 110.682 8.69034C110.341 8.97917 110.083 9.37216 109.908 9.86932C109.738 10.3665 109.652 10.9323 109.652 11.5668C109.652 12.2012 109.738 12.767 109.908 13.2642C110.083 13.7614 110.341 14.1544 110.682 14.4432C111.028 14.7273 111.454 14.8693 111.961 14.8693ZM125.886 6.09091V8.36364H119.316V6.09091H125.886ZM120.808 3.47727H123.833V13.6477C123.833 13.9271 123.876 14.1449 123.961 14.3011C124.046 14.4527 124.165 14.5592 124.316 14.6207C124.472 14.6823 124.652 14.7131 124.856 14.7131C124.998 14.7131 125.14 14.7012 125.282 14.6776C125.424 14.6491 125.533 14.6278 125.609 14.6136L126.085 16.8651C125.933 16.9124 125.72 16.9669 125.445 17.0284C125.171 17.0947 124.837 17.1349 124.444 17.1491C123.715 17.1776 123.076 17.0805 122.526 16.858C121.982 16.6354 121.558 16.2898 121.255 15.821C120.952 15.3523 120.803 14.7604 120.808 14.0455V3.47727Z"
                        fill="black"
                      ></path>
                    </svg>
                  </div>
                  <div className="flex items-center max-[768px]:justify-center space-x-4">
                    <img
                      src="https://uploads-ssl.webflow.com/62fb765fc0871b025cda9b9d/636d00859d8af329582e2c16_Frame%202085660000.svg"
                      alt=""
                    />
                    <h1 className="text-lg text-gray-900 font-medium">4.7 →</h1>
                  </div>
                  <div className="h-[2px] bg-gray-700 rounded-full md:hidden w-full my-5"></div>
                </div>
                <div className="w-[50%]">
                  <a
                    className="text-gray-800 hover:text-gray-600 duration-300 cursor-pointer"
                    href="https://blog.algoostrategies.org/post/algoo-strategies-integrates-with-fireblock"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <svg
                      className="max-[768px]:mx-auto w-[50%]"
                      viewBox="0 0 212 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M114.265 6.05785V13.1213H114.328C115.494 11.5875 117.159 10.8202 119.322 10.8202C120.287 10.8202 121.2 10.978 122.06 11.2931C122.92 11.6081 123.685 12.0831 124.352 12.7188C125.018 13.3539 125.541 14.1475 125.917 15.1003C126.295 16.0525 126.483 17.1526 126.483 18.3999C126.483 19.8058 126.226 21.1121 125.708 22.3188C125.191 23.5263 124.386 24.4927 123.294 25.2202C122.202 25.9469 120.847 26.3117 119.228 26.3117C116.89 26.3117 115.225 25.5658 114.233 24.0753H114.17V25.9256H109.731V6.05785H114.265ZM97.2303 10.4054C105.858 10.4054 105.12 19.6854 105.12 19.6854H93.3094C93.7873 21.5321 95.3748 22.746 97.5623 22.746C100.198 22.746 101.618 21.1517 101.618 21.1517L104.125 23.7174C102.834 25.0009 101.101 26.1735 97.5242 26.1735C91.9936 26.1735 89.0442 22.5078 89.0442 18.6223C89.0442 14.7367 91.2569 10.4054 97.2303 10.4054ZM204.656 10.3986C208.368 10.3986 210.727 11.8159 210.727 11.8159L209.203 15.0905C204.263 12.5248 202.026 14.3332 202.026 15.237C202.026 16.1416 202.911 16.2148 206.352 16.8505C209.793 17.4863 211.391 18.927 211.391 21.2488C211.391 23.5705 209.399 26.1369 204.533 26.1369C199.665 26.1369 197.454 24.5725 197.454 24.5725L198.929 21.322C202.739 23.7419 207.064 22.959 207.064 21.5183C207.064 20.4367 205.627 20.2075 204.078 20.0264L203.412 19.9493C203.116 19.9143 202.823 19.8769 202.542 19.8315C200.576 19.5136 197.651 18.4633 197.651 15.4326C197.651 12.4025 200.945 10.3986 204.656 10.3986ZM182.925 5.02276V17.022L189.377 10.814H194.65L188.255 16.9666L195.276 26.1371H190.041L185.24 19.8679L182.925 22.0944V26.1371H178.611V5.02276H182.925ZM167.464 10.3015C170.524 10.3015 173.203 11.8268 174.684 14.113L171.037 16.2606C170.353 14.9607 169.009 14.0768 167.464 14.0768C165.224 14.0768 163.408 15.9313 163.408 18.219C163.408 20.5059 165.224 22.3612 167.464 22.3612C168.937 22.3612 170.224 21.5555 170.935 20.3537L174.598 22.4515C173.101 24.6659 170.467 26.1372 167.464 26.1372C162.8 26.1372 159.02 22.5916 159.02 18.219C159.02 13.8457 162.8 10.3015 167.464 10.3015ZM147.415 10.3008C152.077 10.3008 155.859 13.8464 155.859 18.2183C155.859 22.5916 152.077 26.1365 147.415 26.1365C142.751 26.1365 138.972 22.5916 138.972 18.2183C138.972 13.8464 142.751 10.3008 147.415 10.3008ZM70.7532 10.7409V25.9907H66.0706V10.7409H70.7532ZM61.8657 6.12199V9.93426H51.3943V14.9931H60.6483V18.7691H51.3943V25.9904H46.7109V6.12199H61.8657ZM80.7468 12.6466C80.7468 12.6466 82.4062 10.0439 85.8348 10.4478V14.6996C85.8348 14.6996 82.1108 13.7467 80.7468 17.5959V25.9899H76.2855V10.7408H80.5507L80.7468 12.5371V12.6466ZM134.508 4.94894V25.8798H129.789V4.94894H134.508ZM117.958 14.1709C115.37 14.1709 114.076 15.7482 114.076 18.9041C114.076 20.1002 114.409 21.1035 115.075 21.9142C115.742 22.7242 116.747 23.1295 118.091 23.1295C118.987 23.1295 119.715 22.8955 120.274 22.4276C120.832 21.959 121.228 21.3866 121.462 20.7089C121.697 20.0319 121.815 19.3556 121.815 18.6808C121.815 17.3837 121.508 16.3092 120.894 15.4538C120.28 14.5983 119.301 14.1709 117.958 14.1709ZM147.415 14.0768C145.174 14.0768 143.359 15.9306 143.359 18.2183C143.359 20.5066 145.174 22.3612 147.415 22.3612C149.655 22.3612 151.47 20.5066 151.47 18.2183C151.47 15.9306 149.655 14.0768 147.415 14.0768ZM97.3036 13.7284C95.0219 13.7284 93.7535 15.1371 93.3252 16.9725H100.972C100.935 16.4953 100.18 13.7284 97.3036 13.7284ZM68.412 3.55566C69.9312 3.55566 71.1644 4.68846 71.1644 6.08509C71.1644 7.48171 69.9312 8.61451 68.412 8.61451C66.892 8.61451 65.6588 7.48171 65.6588 6.08509C65.6588 4.68846 66.892 3.55566 68.412 3.55566Z"
                        fill="black"
                      ></path>
                      <path
                        d="M31.0619 0C31.7672 0 32.339 0.573075 32.339 1.28V30.72C32.339 31.4269 31.7672 32 31.0619 32H1.27711C0.571781 32 0 31.4269 0 30.72V1.28C0 0.573075 0.571781 0 1.27711 0H31.0619ZM16.1694 8.88889L7.18637 23.1111H25.1525L16.1694 8.88889Z"
                        fill="black"
                      ></path>
                    </svg>
                    <h1 className="mt-2 text-lg">Secured by →</h1>
                  </a>
                </div>
              </div>
            </AnimationOnScroll>
          </div>
          <div>
            <AnimationOnScroll animateIn="animate__fadeIn">
              <h1 className="font-medium max-w-[1000px] text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 text-center mx-auto mb-20">
                The first CeDeFi platform to provide financial freedom to its
                investors
              </h1>
            </AnimationOnScroll>
            <AnimationOnScroll
              animateIn="animate__fadeIn"
              className="md:grid space-y-5 md:space-y-0 grid-cols-4 gap-5 mb-36"
            >
              <div className="p-5 rounded-md bg-[#181b20]">
                <div className="mb-2">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.6673 1.66764C17.494 1.66699 17.3062 1.66699 17.1012 1.66699H12.334C9.53372 1.66699 8.13359 1.66699 7.06403 2.21196C6.12322 2.69133 5.35832 3.45623 4.87895 4.39704C4.33398 5.4666 4.33398 6.86673 4.33398 9.66699V22.3337C4.33398 25.1339 4.33398 26.5341 4.87895 27.6036C5.35832 28.5444 6.12322 29.3093 7.06403 29.7887C8.13359 30.3337 9.53372 30.3337 12.334 30.3337H19.6673C22.4676 30.3337 23.8677 30.3337 24.9373 29.7887C25.8781 29.3093 26.643 28.5444 27.1223 27.6036C27.6673 26.5341 27.6673 25.1339 27.6673 22.3337V12.2332C27.6673 12.0282 27.6673 11.8404 27.6667 11.667H21.8673H21.8288H21.8288C21.3016 11.667 20.8469 11.667 20.4723 11.6364C20.0769 11.6041 19.6837 11.5328 19.3053 11.34C18.7409 11.0524 18.2819 10.5935 17.9943 10.029C17.8015 9.6506 17.7302 9.25738 17.6979 8.86204C17.6673 8.48746 17.6673 8.0327 17.6673 7.50555L17.6673 7.46701V1.66764ZM27.489 9.66701C27.3645 9.21347 27.1765 8.77949 26.9305 8.37802C26.6213 7.87344 26.1889 7.44106 25.3242 6.57632L25.3242 6.5763L22.758 4.01014C21.8933 3.14538 21.4609 2.713 20.9563 2.40379C20.5548 2.15777 20.1209 1.96984 19.6673 1.84534V7.46701C19.6673 8.04356 19.6681 8.41584 19.6912 8.69917C19.7134 8.97084 19.7511 9.07156 19.7763 9.121C19.8722 9.30916 20.0252 9.46214 20.2133 9.55802C20.2628 9.58321 20.3635 9.62089 20.6352 9.64308C20.9185 9.66623 21.2908 9.66701 21.8673 9.66701H27.489ZM20.7078 16.7075C21.0983 16.3169 21.0983 15.6838 20.7078 15.2932C20.3172 14.9027 19.6841 14.9027 19.2935 15.2932L14.6673 19.9195L13.3744 18.6266C12.9839 18.236 12.3507 18.236 11.9602 18.6266C11.5697 19.0171 11.5697 19.6503 11.9602 20.0408L13.9602 22.0408C14.3507 22.4313 14.9839 22.4313 15.3744 22.0408L20.7078 16.7075Z"
                      fill="white"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                    Licensed
                  </h2>
                  <p className="text-gray-400 text-sm font-medium">
                    Licensed, fully regulated institution. Available for EU&US
                    customers.
                  </p>
                </div>
              </div>
              <div className="p-5 rounded-md bg-[#181b20]">
                <div className="mb-2">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M30.7363 0C31.4342 0 32 0.573075 32 1.28V30.72C32 31.4269 31.4342 32 30.7363 32H1.26372C0.565787 32 0 31.4269 0 30.72V1.28C0 0.573075 0.565787 0 1.26372 0H30.7363ZM15.9999 8.88889L7.11104 23.1111H24.8888L15.9999 8.88889Z"
                      fill="white"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                    Protected
                  </h2>
                  <p className="text-gray-400 text-sm font-medium">
                    Customer's funds are protected by{" "}
                    <a
                      className="text-[#b2ffce] underline"
                      href="https://blog.algoostrategies.org/post/algoo-strategies-integrates-with-fireblock"
                    >
                      Fireblocks
                    </a>
                  </p>
                </div>
              </div>
              <div className="p-5 rounded-md bg-[#181b20]">
                <div className="mb-2">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.6673 1.66764C17.494 1.66699 17.3062 1.66699 17.1012 1.66699H12.334C9.53372 1.66699 8.13359 1.66699 7.06403 2.21196C6.12322 2.69133 5.35832 3.45623 4.87895 4.39704C4.33398 5.4666 4.33398 6.86673 4.33398 9.66699V22.3337C4.33398 25.1339 4.33398 26.5341 4.87895 27.6036C5.35832 28.5444 6.12322 29.3093 7.06403 29.7887C8.13359 30.3337 9.53372 30.3337 12.334 30.3337H19.6673C22.4676 30.3337 23.8677 30.3337 24.9373 29.7887C25.8781 29.3093 26.643 28.5444 27.1223 27.6036C27.6673 26.5341 27.6673 25.1339 27.6673 22.3337V12.2332C27.6673 12.0282 27.6673 11.8404 27.6667 11.667H21.8673H21.8288H21.8288C21.3016 11.667 20.8469 11.667 20.4723 11.6364C20.0769 11.6041 19.6837 11.5328 19.3053 11.34C18.7409 11.0524 18.2819 10.5935 17.9943 10.029C17.8015 9.6506 17.7302 9.25738 17.6979 8.86204C17.6673 8.48746 17.6673 8.0327 17.6673 7.50555L17.6673 7.46701V1.66764ZM27.489 9.66701C27.3645 9.21347 27.1765 8.77949 26.9305 8.37802C26.6213 7.87344 26.1889 7.44106 25.3242 6.57632L25.3242 6.5763L22.758 4.01014C21.8933 3.14538 21.4609 2.713 20.9563 2.40379C20.5548 2.15777 20.1209 1.96984 19.6673 1.84534V7.46701C19.6673 8.04356 19.6681 8.41584 19.6912 8.69917C19.7134 8.97084 19.7511 9.07156 19.7763 9.121C19.8722 9.30916 20.0252 9.46214 20.2133 9.55802C20.2628 9.58321 20.3635 9.62089 20.6352 9.64308C20.9185 9.66623 21.2908 9.66701 21.8673 9.66701H27.489ZM12.0007 15.0003C11.4484 15.0003 11.0007 15.4481 11.0007 16.0003C11.0007 16.5526 11.4484 17.0003 12.0007 17.0003H20.0007C20.5529 17.0003 21.0007 16.5526 21.0007 16.0003C21.0007 15.4481 20.5529 15.0003 20.0007 15.0003H12.0007ZM12.0007 20.3337C11.4484 20.3337 11.0007 20.7814 11.0007 21.3337C11.0007 21.886 11.4484 22.3337 12.0007 22.3337H17.334C17.8863 22.3337 18.334 21.886 18.334 21.3337C18.334 20.7814 17.8863 20.3337 17.334 20.3337H12.0007Z"
                      fill="white"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                    Transparent
                  </h2>
                  <p className="text-gray-400 text-sm font-medium">
                    Quarterly Investment Reports provide{" "}
                    <a
                      className="text-[#b2ffce] underline"
                      href="https://wiki.algoostrategies.org/algoo-strategies-wiki/resources/investment-reports"
                    >
                      transparency
                    </a>{" "}
                    in how Algoo Strategies generates yield
                  </p>
                </div>
              </div>
              <div className="p-5 rounded-md bg-[#181b20]">
                <div className="mb-2">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M19.9987 1.66602C19.4464 1.66602 18.9987 2.11373 18.9987 2.66602C18.9987 3.2183 19.4464 3.66602 19.9987 3.66602C22.3919 3.66602 24.332 5.60611 24.332 7.99935C24.332 10.3926 22.3919 12.3327 19.9987 12.3327C19.4464 12.3327 18.9987 12.7804 18.9987 13.3327C18.9987 13.885 19.4464 14.3327 19.9987 14.3327C23.4965 14.3327 26.332 11.4972 26.332 7.99935C26.332 4.50155 23.4965 1.66602 19.9987 1.66602ZM22.6654 17.666C22.1131 17.666 21.6654 18.1137 21.6654 18.666C21.6654 19.2183 22.1131 19.666 22.6654 19.666H24.2654C27.2477 19.666 29.6654 22.0837 29.6654 25.066C29.6654 26.8701 28.2028 28.3327 26.3987 28.3327H22.6654C22.1131 28.3327 21.6654 28.7804 21.6654 29.3327C21.6654 29.885 22.1131 30.3327 22.6654 30.3327H26.3987C29.3074 30.3327 31.6654 27.9747 31.6654 25.066C31.6654 20.9791 28.3523 17.666 24.2654 17.666H22.6654ZM4.33203 7.99935C4.33203 4.50155 7.16756 1.66602 10.6654 1.66602C14.1632 1.66602 16.9987 4.50155 16.9987 7.99935C16.9987 11.4972 14.1632 14.3327 10.6654 14.3327C7.16756 14.3327 4.33203 11.4972 4.33203 7.99935ZM7.73203 17.666C3.64512 17.666 0.332031 20.9791 0.332031 25.066C0.332031 27.9747 2.69 30.3327 5.5987 30.3327H15.732C18.6407 30.3327 20.9987 27.9747 20.9987 25.066C20.9987 20.9791 17.6856 17.666 13.5987 17.666H7.73203Z"
                      fill="white"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h2 className="font-medium text-[20px] text-left leading-[24px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 mb-4">
                    Team
                  </h2>
                  <p className="text-gray-400 text-sm font-medium">
                    A{" "}
                    <a
                      href="https://wiki.algoostrategies.org/algoo-strategies-wiki/introduction/team"
                      className="text-[#b2ffce] underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      team
                    </a>{" "}
                    of 50 associates, including a robust, 25-member investment
                    department
                  </p>
                </div>
              </div>
            </AnimationOnScroll>
          </div>
          <div className="mb-36 mt-20">
            <AnimationOnScroll
              animateIn="animate__fadeIn"
              className="text-center my-10"
            >
              <p className="font-medium text-2xl leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-[#b2ffce] to-purple-200 text-center">
                Innovative Investment Tool
              </p>
              <div>
                <h1 className="text-gray-300 font-medium mt-3 text-4xl">
                  High ROI CeDeFi Strategies
                </h1>
                <p className="text-gray-400 font-medium mt-3 text-lg max-w-md mx-auto">
                  Strategies with variable risk-reward levels, powered by
                  algorithmic tools utilizing select DeFi protocols
                </p>
              </div>
            </AnimationOnScroll>
            <AnimationOnScroll animateIn="animate__fadeIn">
              <LeaderboardTable />
            </AnimationOnScroll>
          </div>
          <div className="text-white">
            <Tiers />
          </div>
          <AnimationOnScroll animateIn="animate__fadeIn" className="pt-32">
            <h1 className="font-medium text-5xl leading-[50px] text-transparent mb-12 bg-clip-text bg-gradient-to-r to-[#b2ffce] from-purple-200 text-center">
              Why use us
            </h1>
          </AnimationOnScroll>
          <AnimationOnScroll
            className="lg:grid grid-cols-3 gap-10 pb-32"
            animateIn="animate__fadeIn"
          >
            <div className="">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-12 h-12 text-[#b2ffce] mx-auto"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
                  />
                </svg>
              </div>
              <div className="">
                <h1 className="text-center font-medium text-2xl text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 my-6">
                  Ready-made vaults of the complex DeFi strategies
                </h1>
                <p className="text-gray-300">
                  Sets of approved strategies into one-click vaults of manually
                  managing numerous complex protocols. compound Algoo Strategies
                  maximizes yields through interest, leveraging diversifying
                  invested positions, assets in optimizing strategies, gas fees,
                  even and within the same vault.
                </p>
              </div>
            </div>
            <div className="">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-12 h-12 text-[#b2ffce] mx-auto"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
                  />
                </svg>
              </div>
              <div className="">
                <h1 className="text-center font-medium text-2xl text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 my-6">
                  Transparency via on-chain infrastructure
                </h1>
                <p className="text-gray-300">
                  On-chain strategies reduce third-party risks and allow for
                  transparent tracking of transactions. As an investor, you'll
                  receive an ERC-20 token upon your deposit, which grants you
                  the ability to reclaim deposited assets.
                </p>
              </div>
            </div>
            <div className="">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-12 h-12 text-[#b2ffce] mx-auto"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 7.5l-2.25-1.313M21 7.5v2.25m0-2.25l-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3l2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75l2.25-1.313M12 21.75V19.5m0 2.25l-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
                  />
                </svg>
              </div>
              <div className="">
                <h1 className="text-center font-medium text-2xl text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 my-6">
                  The top-notch team is putting together DeFi strategies for you
                </h1>
                <p className="text-gray-300">
                  We're experienced in managing a $150M crypto-fund for 5 years,
                  generating a steady 24% annual return through market ups and
                  downs.
                </p>
              </div>
            </div>
          </AnimationOnScroll>
          <div>
            <AnimationOnScroll animateIn="animate__fadeIn">
              <h1 className="font-medium text-[42px] leading-[50px] text-transparent bg-clip-text bg-gradient-to-r from-purple-200 via-[#b2ffce] to-purple-200 text-center mb-10">
                FAQ
              </h1>
            </AnimationOnScroll>

            <AnimationOnScroll animateIn="animate__fadeIn" className="md:px-32">
              <Faq />
            </AnimationOnScroll>
          </div>
        </div>
        <div>
          <CallToAction />
        </div>
        <div className="px-5 sm:px-10 md:px-20 lg:px-32">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Home;
